import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

const remindersRoot = ["reminders"] as const;

export const RemindersKeys = {
	all: remindersRoot,
	lists: [...remindersRoot, "list"] as const,
	types: (entity: ReminderEntity) =>
		[...RemindersKeys.all, "types", entity.type, entity.id] as const,
	portfolioList: (portfolioId: number) =>
		[
			...RemindersKeys.lists,
			ReminderEntityTypeEnum.Portfolio,
			portfolioId,
		] as const,
	identificationDocumentList: (documentId: number) =>
		[
			...RemindersKeys.lists,
			ReminderEntityTypeEnum.IdentificationDocument,
			documentId,
		] as const,
	propertyList: (propertyId: number) =>
		[
			...RemindersKeys.lists,
			ReminderEntityTypeEnum.Property,
			propertyId,
		] as const,
};
